var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.files.length > 0)?_c('b-dropdown',{staticClass:"mr-1",attrs:{"right":"","size":"sm","text":_vm.buttonText}},_vm._l((_vm.files),function(file,index){return _c('b-dropdown-item',{key:index,attrs:{"href":`/api/media/file/${file.path}?jwt=${_vm.accessToken}`,"target":"_blank"}},[_vm._v(" "+_vm._s(file.label)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }